import Vue from 'vue';

export default {
  props: {
    columns: Array
  },
  render(h) {
    const _vue = window["Vue"] as Vue;
    // 创建table的列结构
    const buildHead = columns => {
      if (!columns) {
        return;
      }
      return columns.map(column => {
        return createColumn(column);
      });
    };

    // 构建table的列属性
    const createColumn = column => {
      return (
        <el-table-column  {...createAttribute(column)}>
          {buildHead(column.columns)}
        </el-table-column>
      );
    };

    /*
      data直接通过...的方式附加prop属性到组件无法实现渲染,
      这里创建为{attrs:data}的格式,实现组件的响应式渲染
    */
    const createAttribute = column => {

      const scopedSlots = createControls(column);

      let data = { ...column };

      if (column.attrs && column.attrs.sortable === true) {
        data = Object.assign(data, { sortable: "custom" });
      }

      data.showOverflowTooltip = true;

      return {
        attrs: data,
        scopedSlots
      };
    };

    const createControls = column => {
      let scopedSlots;
      if (column.attrs) {
        switch (column.attrs.type) {
          case 'string':
            scopedSlots = InputEx(column);
            break;
          case 'number':
            scopedSlots = NumberEx(column);
            break;
          case 'datetime':
          case 'date':
            scopedSlots = DataEx(column);
            break;
          case 'time':
            scopedSlots = TimeEx(column);
            break;
          case 'select':
            scopedSlots = SelectEx(column);
            break;
          case 'boolean':
            scopedSlots = BooleanEx(column);
            break;
        }
      } else {
        scopedSlots = {
          default: props => {
            if (column.render) {
              return column.render(props);
            }
            else {
              return (
                <div>
                  {props.row[column.prop]}
                </div>
              );
            }
          }
        }
      }
      return scopedSlots;
    }

    const InputEx = column => {
      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-input
                  style='width:100%'
                  onInput={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  value={props.row[column.prop]}
                  maxlength={column.attrs.maxlength || 8096}
                  minlength={column.attrs.minlength || 0}
                />
              </div>
            );
          } else {
            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props)
            }
            else {
              return <div>{column.formatter ? column.formatter(props.row, props.column, props.row[column.prop], props.$index) : props.row[column.prop]}</div>;
            }
          }
        }
      };
    }

    const NumberEx = column => {
      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-input-number
                  style='width:100%'
                  onInput={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  controls={false}
                  value={props.row[column.prop]}
                  controls-position='right'
                  precision={column.attrs.precision || 0}
                  min={column.attrs.min || -2147483648}
                  max={column.attrs.max || 2147483647}
                />
              </div>
            );
          } else {
            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props)
            }
            return <div>{column.formatter ? column.formatter(props.row, props.column, props.row[column.prop], props.$index) : (props.row[column.prop]?props.row[column.prop].toFixed((column.attrs.precision || 0))*1:0)}</div>;
          }
        }
      }
    }

    const DataEx = column => {
      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-date-picker
                  style='width:100%'
                  onInput={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  type={column.attrs.type}
                  value={props.row[column.prop]}
                />
              </div>
            );
          } else {
            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props)
            }
            return (
              <div>
                {column.formatter ? column.formatter(props.row, props.column, props.row[column.prop], props.$index) : props.row[column.prop] ? _vue.$moment(
                  new Date(props.row[column.prop])).format(
                  column.attrs.type === 'datetime'
                    ? 'YYYY-MM-DD HH:mm:ss'
                    : 'YYYY-MM-DD'
                ) : ""}
              </div>
            );
          }
        }
      }
    }

    const TimeEx = column => {
      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-time-picker
                  style='width:100%'
                  onInput={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  value={props.row[column.prop]}
                />
              </div>
            );
          } else {
            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props)
            }
            return (
              <div>
                {column.formatter ? column.formatter(props.row, props.column, props.row[column.prop], props.$index) : props.row[column.prop] ? _vue.$moment(
                  new Date(props.row[column.prop])).format(
                  'HH:mm:ss'
                ) : ""}
              </div>
            );
          }
        }
      }
    }

    const SelectEx = column => {

      // 创建下拉框对象
      const createOptions = column => {
        return (typeof column.attrs.options === 'function' ? column.attrs.options() : (column.attrs.options || [])).map(item => {
          return (<el-option
              key={item[column.attrs.value || 'value']}
              label={item[column.attrs.label || 'label']}
              value={item[column.attrs.value || 'value']}
            />
          );
        });
      };

      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-select
                  onChange={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  value={props.row[column.prop]}
                  filterable
                >
                  {createOptions(column)}
                </el-select>
              </div>
            );
          } else {

            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props,(typeof column.attrs.options === 'function' ? column.attrs.options() : (column.attrs.options || [])))
            }


            if (column.formatter) {
              return <span>{column.formatter(props.row, props.column, props.row[column.prop], props.$index)}</span>
            }

            if (column.attrs.options) {
              if (typeof column.attrs.options === 'function') {
                return column.attrs.options();
              }
              else {
                const item = column.attrs.options.find(item => item.value === props.row[column.prop]);
                if (item) {
                  return <span>{column.attrs.options.find(item => item.value === props.row[column.prop])["label"]}</span>
                } else {
                  return <span>{props.row[column.prop]}</span>
                }
              }

            }
            return props.row[column.prop]
          }
        }
      }
    }

    const BooleanEx = column => {
      return {
        default: props => {
          if (column.attrs.editable && props.row.$editable) {
            return (
              <div>
                <el-switch
                  onChange={val => {
                    if (column.attrs.change) {
                      column.attrs.change(val, props.row[column.prop], props.row,props)
                    }
                    props.row[column.prop] = val
                  }}
                  value={props.row[column.prop]}
                  active-value={1}
                  inactive-value={0}></el-switch>
              </div>
            );
          } else {
            if (!(props.row.$editable && column.attrs.editable) && column.render) {
              return column.render(props)
            }
            return column.formatter ? column.formatter(props.row, props.column, props.row[column.prop], props.$index) : <div>
              <el-switch
                disabled
                value={props.row[column.prop]}
                active-value={1}
                inactive-value={0}>
              </el-switch>
            </div>;
          }
        }
      };
    }

    if (this.columns) {
      return (
        <div>
          {buildHead(this.columns)}
        </div>
      )
    } else {
      return <div></div>
    }
  }
}
